class _loading {

  constructor() {}

  once(isTop, compFunc) {
    this.isTop = isTop;
    this.compFunc = compFunc;
    this.el = document.getElementById('c-loading');

    if (this.isTop) {
      // webGLを待つ
      window.addEventListener('GL_ON_LOAD', this.topReady.bind(this));
    } else {
      requestAnimationFrame(this.ready.bind(this));
    }
  }

  topReady() {
    _glMain.glStart();
    this.ready();
  }

  ready() {
    this.hide();


  }

  /** ローディング非表示 */
  hide() {
    if (this.isEnd) return;

    gsap.to(this.el, {
      duration: 1.0,
      opacity: 0,
      display: 'none',
      ease: Power3.easeOut,
      onComplete: this.hideComp.bind(this)
    });

    // ページを表示
    //document.getElementById('c-siteWrap').style.visibility = 'visible';

    if (this.compFunc) this.compFunc();
  }

  /** ローディング非表示 */
  hideComp() {
    if (this.isEnd) return;
    this.isEnd = true;
  }
}

const loading = new _loading();

export default loading;